import { c } from "./colors";
import { Frame, type IllustrationProps } from "./Frame";

export function AutoRepliesIllustration(props: IllustrationProps) {
  return (
    <Frame {...props}>
      <rect
        x="40"
        y="24"
        width="80"
        height="32"
        rx="12"
        fill={c.n0}
        stroke={c.p200}
        strokeWidth="2"
      />
      <rect x="56" y="37" width="48" height="6" rx="3" fill={c.p200} />
      <path d="M80 64v24M71 80l9 9 9-9" stroke={c.a400} strokeWidth="5" />
      <rect x="40" y="96" width="80" height="34" rx="12" fill={c.p500} />
      <circle cx="68" cy="113" r="4" fill={c.n0} />
      <circle cx="80" cy="113" r="4" fill={c.n0} />
      <circle cx="92" cy="113" r="4" fill={c.n0} />
    </Frame>
  );
}
